<div class="modal-header">
  <h4 class="modal-title">{{ newEmail ? 'Email address' : 'Phone number' }} update requested</h4>
</div>
<div class="modal-body">
  <p>
    @if (newEmail) {
      An email has been sent to <strong>{{ newEmail }}</strong> for verification. <br />
      Once it's verified, the new email address will reflect on the employee's profile.
    }
    @if (phone) {
      An email has been sent to <strong>{{ existingEmail }}</strong> with steps to verify the new phone number:
      {{ maskService.formatInternationalPhone(phone) }}.<br />
      Once it's verified, the new phone number will reflect on the employee's profile.
    }
  </p>
</div>

<div class="modal-footer">
  <button
    id="modalAcceptBtn"
    class="btn btn-primary"
    type="submit"
    (click)="onDismiss()">
    Got it
  </button>
</div>
